import React, {Component} from 'react';
import './StepOffices.css';
import ApiConnector from '../api/ApiConnector';
import GlobalStore from '../../store/GlobalStore';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import ReactQueryParams from 'react-query-params';
import TagManager from 'react-gtm-module';
import {config} from '../../config.js';

var parentThis;

class StepOffices extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            apiOffices: [],
            loader: true,
            parentCategoryId: undefined,
        };
    }

    componentDidMount() {
        let getApiOffices = ApiConnector.getOffices(GlobalStore.getInstance().data['categories']);

        getApiOffices
            .then(data => {
                if (data.ok !== undefined && !data.ok) {
                    throw Error('MAINTENANCE_MODE');
                }

                data.unshift({Name: 'Kaikki', Address: {City:'', Country:'',PostalCode:'',Street:''}, Id:'all', IsArchived: false, Description: 'Kelpuuttaa kaikkien toimipisteiden vapaat ajat'});

                GlobalStore.getInstance().data['officesList'] = {};
                let resultApiOffices = data.map((item) => {
                    GlobalStore.getInstance().data['officesList'][item.Id] = item;
                    let setOfficeClickProcessor = this.setOfficeOnClick.bind(this, item);
                    return (
                        <div className="col-md-6 col-xs-12" key={item.Id}>
                            <div className="stepOfficesItem" onClick={setOfficeClickProcessor} key={item.Id}>
                                <div className="officeItemName">{item.Name}</div>
                                {item.Id == 'all' ? (
                                    <div className="officeItemDisc">{item.Description}.</div>
                                ) : (
                                    <div className="officeItemDisc">{item.Address.Street}, {item.Address.PostalCode}, {item.Address.City}, {item.Address.Country}.</div>
                                )}
                                <span className="ripplesCircle"></span>
                            </div>
                        </div>
                    )
                });
                this.setState({apiOffices: resultApiOffices, loader: false});

            }).catch(error => {
            if (error.toString() === "Error: MAINTENANCE_MODE") {
                this.setState({loader: false});
                NotificationManager.error('Järjestelmässä on parhaillaan huoltokatko. Pahoittelemme häiriötä.', 'Yhteysongelma', 1000000, () => {
                    this.componentDidMount();
                });
            } else {
                this.setState({loader: false});
                NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                    this.componentDidMount();
                });
            }
        });
    }

    setOfficeOnClick(item, e) {

        this.setState({loader: true});

        GlobalStore.getInstance().data['office'] = item.Id;
        GlobalStore.getInstance().data['officeName'] = item.Name;
        GlobalStore.getInstance().data['officeAddress'] = [item.Address.Street,item.Address.PostalCode,item.Address.City,item.Address.Country].join(', ')+'.';

        const tagManagerArgsResultConfirmPage = {
            dataLayer: {
                event: 'select_content',
                content_type: 'office',
                content_id: GlobalStore.getInstance().data['officeName']
            }
        };

        if (this.queryParams.env !== "test" && config.environment === "prod") {
            TagManager.dataLayer(tagManagerArgsResultConfirmPage);
        }

        this.nextStep();
    }

    render() {

        parentThis = this;

        return (
            <div className="stepOffices col-xs-12">
                {(this.state.loader === true) ? <div className="globalLoader">
                    <div className="globalSpinner"></div>
                </div> : ''}
                {this.state.apiOffices}

                <NotificationContainer/>

            </div>
        )
    };

    nextStep(e) {
        parentThis.props.nextStep();
    };
}

export default StepOffices;



// WEBPACK FOOTER //
// ./src/components/Step_2/StepOffices.jsx